// extracted by mini-css-extract-plugin
export default {"Details":"Profile_Details__xbIz3"};